"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = text;
var _getClosestTranslationTarget = require("../utils/getClosestTranslationTarget");
/**
 * @typedef  {Object} ReturnType
 * @property  {string} text
 */

/**
 * Only to be used with nature category translates
 * @param  {string} value
 * @param  {string} category 'nature'
 * @param  {string} dataSource 'norway'
 * @returns {ReturnType} translate_text
 */
function text(_ref) {
  var value = _ref.value,
    category = _ref.category,
    dataSource = _ref.dataSource;
  var closestTarget = (0, _getClosestTranslationTarget.getClosestTranslationTarget)(value, category, dataSource);
  var translate_text = "translate.".concat(category, "_text.").concat(closestTarget);
  return {
    text: translate_text
  };
}
//# sourceMappingURL=index.js.map